import styled, { css } from "styled-components";
import { InputGroupProps } from "types/InputGroup";

export const InputGroup = styled.div<InputGroupProps>`
  margin-top: 1rem;

  label {
    font-size: 1rem;
    color: ${props => props.theme.colors.muted};
  }

  .input-error-message {
    font-size: .8rem;
    display: block;
    margin-top: 5px;
    color: ${props => props.theme.colors.danger};
  }

  ${props => props.noSpacing && css`
    margin-top: 0;
  `}

  ${props => props.flexItem && css`
    flex: 1 0 0;
  `}
`;

export const InputGroupButton = styled.div<InputGroupProps>`
  display: flex;
  flex-direction: row;
  gap: 10px;
  margin-top: 1rem;

  label {
    font-size: 1rem;
    color: ${props => props.theme.colors.muted};
  }

  .input-error-message {
    font-size: .8rem;
    display: block;
    margin-top: 5px;
    color: ${props => props.theme.colors.danger};
  }

  ${props => props.noSpacing && css`
    margin-top: 0;
  `}

  ${props => props.flexItem && css`
    flex: 1 0 0;
  `}
`
